function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import EmailEditor from 'react-email-editor';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import CommonModal from './CommonModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Template(props) {
  var emailEditorRef = useRef(null);
  var saveProposalRef = useRef(null);
  var axios = require('axios')["default"];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    TemplateId = _useState2[0],
    setTemplateId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];
  var exportHtml = function exportHtml() {
    emailEditorRef.current.editor.exportHtml(function (data) {
      var design = data.design,
        html = data.html;
    });
  };
  var onLoad = function onLoad() {
    axios.get('/contract/view_template_design/' + TemplateId).then(function (response) {
      // handle success
      emailEditorRef.current.editor.loadDesign(response.data);
    })["catch"](function (error) {
      // handle error
      console.log(error);
    }).then(function () {
      // always executed
    });
  };
  var saveDesign = function saveDesign() {
    emailEditorRef.current.editor.exportHtml(function (data) {
      var design = data.design,
        html = data.html;
      emailEditorRef.current.editor.saveDesign(function (design) {
        axios.post('/contract/save_template', {
          content: design,
          html: html,
          TemplateId: TemplateId
        }).then(function (response) {
          // handle success
          setMessage("Template saved successfully");
          setTimeout(function () {
            setMessage("");
          }, 500);
        })["catch"](function (error) {
          // handle error
          console.log(error);
        }).then(function () {
          // always executed
        });
      });
    });
  };
  useEffect(function () {
    var id = document.getElementById('templateId').value;
    setTemplateId(id);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "result",
      children: message
    }), /*#__PURE__*/_jsx("div", {
      className: "save_export_btn",
      children: /*#__PURE__*/_jsx("button", {
        className: "ws_btn ws_btn_sm",
        onClick: saveDesign,
        children: "Save"
      })
    }), /*#__PURE__*/_jsx(EmailEditor, {
      minHeight: "75vh",
      tools: {
        menu: {
          enabled: false
        }
      },
      ref: emailEditorRef,
      onLoad: onLoad
    })]
  });
}
export default Template;